export interface Scene {
  id: string;
  /** ledger number, default list order */
  seq?: number;
  name: string;
  description: string;
  lat: number;
  lng: number;
  triggerRadius: number;
  visibility: "public" | "private";
  voice: string;
  audioStatus: "generated" | "pending" | "none";
  knowledgeCount: number;
  status: "active" | "inactive";
  imageCount: number;
  /** basic-info extras (exguide exhibit parity) */
  recognitionHint?: string;
  coverUrl?: string;
  tags?: string[];
  /** scene group (collapsible list sections), "" = ungrouped */
  groupId?: string;
  /** 标准点位：true=可被其它游线"从点位库导入"复用；false=私有，只在所属游线展示 */
  isStandard?: boolean;
  triggerMode?: "circle" | "strip";
  triggerHeadingDeg?: number | null;
  triggerWidthM?: number | null;
}

export const sceneStats = {
  totalScenes: 28,
  activeScenes: 24,
  knowledgeCount: 156,
  audioGenerated: 22,
};

export const scenes: Scene[] = [
  {
    id: "1",
    name: "西陵峡口",
    description: "西陵峡是长江三峡中最长的峡谷，全长66公里，以滩多水急著称。",
    lat: 30.8241,
    lng: 111.2864,
    triggerRadius: 300,
    visibility: "public",
    voice: "鲟侠船长",
    audioStatus: "generated",
    knowledgeCount: 12,
    status: "active",
    imageCount: 8,
  },
  {
    id: "2",
    name: "三峡大坝",
    description: "世界上最大的水利枢纽工程，坝高185米，总装机容量2250万千瓦。",
    lat: 30.8239,
    lng: 111.0036,
    triggerRadius: 500,
    visibility: "public",
    voice: "鲟侠船长",
    audioStatus: "generated",
    knowledgeCount: 18,
    status: "active",
    imageCount: 15,
  },
  {
    id: "3",
    name: "葛洲坝",
    description: "长江上第一座大型水利枢纽，1981年全面建成，坝高47米。",
    lat: 30.7394,
    lng: 111.2867,
    triggerRadius: 400,
    visibility: "public",
    voice: "金梅导游",
    audioStatus: "generated",
    knowledgeCount: 10,
    status: "active",
    imageCount: 6,
  },
  {
    id: "4",
    name: "黄牛岩",
    description: "黄牛岩是西陵峡中的著名景点，相传大禹治水时神牛助其开山。",
    lat: 30.9123,
    lng: 111.1567,
    triggerRadius: 250,
    visibility: "public",
    voice: "鲟侠船长",
    audioStatus: "generated",
    knowledgeCount: 8,
    status: "active",
    imageCount: 5,
  },
  {
    id: "5",
    name: "石牌要塞",
    description: "二战时期著名的石牌保卫战发生地，被誉为\u0022东方的斯大林格勒\u0022。",
    lat: 30.8456,
    lng: 111.1234,
    triggerRadius: 200,
    visibility: "public",
    voice: "金梅导游",
    audioStatus: "generated",
    knowledgeCount: 14,
    status: "active",
    imageCount: 9,
  },
  {
    id: "6",
    name: "三游洞",
    description: "唐代白居易、白行简、元稹三人同游而得名，洞内钟乳石奇特。",
    lat: 30.7654,
    lng: 111.2345,
    triggerRadius: 150,
    visibility: "public",
    voice: "鲟侠船长",
    audioStatus: "pending",
    knowledgeCount: 11,
    status: "active",
    imageCount: 7,
  },
  {
    id: "7",
    name: "南津关",
    description: "长江三峡的东大门，是西陵峡的终点，自古为兵家必争之地。",
    lat: 30.6987,
    lng: 111.3456,
    triggerRadius: 350,
    visibility: "public",
    voice: "金梅导游",
    audioStatus: "generated",
    knowledgeCount: 9,
    status: "active",
    imageCount: 4,
  },
  {
    id: "8",
    name: "屈原故里",
    description: "屈原的故乡，位于秭归县，有屈原祠、屈原墓等历史遗迹。",
    lat: 30.9234,
    lng: 110.8765,
    triggerRadius: 400,
    visibility: "public",
    voice: "鲟侠船长",
    audioStatus: "generated",
    knowledgeCount: 16,
    status: "active",
    imageCount: 11,
  },
  {
    id: "9",
    name: "秭归港",
    description: "三峡库区重要的港口，是三峡大坝上游的航运枢纽。",
    lat: 30.9456,
    lng: 110.8765,
    triggerRadius: 200,
    visibility: "private",
    voice: "金梅导游",
    audioStatus: "none",
    knowledgeCount: 5,
    status: "inactive",
    imageCount: 3,
  },
  {
    id: "10",
    name: "太平溪",
    description: "太平溪是三峡大坝上游的支流，风景秀丽，有众多生态资源。",
    lat: 30.8345,
    lng: 111.0123,
    triggerRadius: 250,
    visibility: "public",
    voice: "鲟侠船长",
    audioStatus: "pending",
    knowledgeCount: 7,
    status: "active",
    imageCount: 5,
  },
  {
    id: "11",
    name: "白帝城",
    description: "刘备托孤之地，有\u0022朝辞白帝彩云间\u0022的千古名句。",
    lat: 31.0456,
    lng: 109.5678,
    triggerRadius: 300,
    visibility: "public",
    voice: "金梅导游",
    audioStatus: "generated",
    knowledgeCount: 15,
    status: "active",
    imageCount: 10,
  },
  {
    id: "12",
    name: "巫山神女峰",
    description: "巫山十二峰之最，传说为瑶姬所化，云雾缭绕时若隐若现。",
    lat: 31.1234,
    lng: 109.8765,
    triggerRadius: 350,
    visibility: "public",
    voice: "鲟侠船长",
    audioStatus: "generated",
    knowledgeCount: 13,
    status: "active",
    imageCount: 8,
  },
];

export const sceneDetailImages = [
  { id: "1", url: "/assets/img/358b4462fed61204.jpg", tags: ["峡谷入口", "航拍"], description: "西陵峡口航拍全景，展现三峡壮丽山川", analyzed: true },
  { id: "2", url: "/assets/img/b3866daab7fc44aa.jpg", tags: ["摩崖石刻", "文物"], description: "", analyzed: false },
  { id: "3", url: "/assets/img/ff66c8cf04fcab3b.jpg", tags: ["游船", "古风"], description: "传统游船穿越峡谷的场景", analyzed: true },
  { id: "4", url: "/assets/img/fa9a29d57f557863.jpg", tags: ["大坝", "工程"], description: "从观景平台拍摄的三峡大坝", analyzed: true },
  { id: "5", url: "/assets/img/54146d6a9d8508ab.jpg", tags: ["晨雾", "山水画"], description: "", analyzed: false },
  { id: "6", url: "/assets/img/f967ce8754cbcea8.jpg", tags: ["古庙", "悬崖"], description: "悬崖上的古寺，俯瞰长江", analyzed: true },
];

export const sceneKnowledge = [
  { id: "1", title: "西陵峡的形成", content: "西陵峡形成于约7000万年前的喜马拉雅造山运动，长江在此切穿了坚硬的石英砂岩层，形成了长达66公里的深切峡谷。", source: "地质资料" },
  { id: "2", title: "兵书宝剑峡传说", content: "相传三国时期诸葛亮在此藏兵书于石壁之中，其宝剑化为宝剑峰。", source: "民间传说" },
  { id: "3", title: "长江航运历史", content: "长江三峡段自古就是重要的航运通道，但因滩险水急，历史上被称为\u0022鬼门关\u0022。", source: "航运志" },
  { id: "4", title: "三峡大坝工程数据", content: "三峡大坝坝顶高程185米，正常蓄水位175米，总库容393亿立方米，总装机容量2250万千瓦。", source: "工程资料" },
  { id: "5", title: "珍稀鱼类保护", content: "三峡库区是中华鲟、白鲟等珍稀鱼类的产卵场，建有专门的鱼类增殖放流站。", source: "生态资料" },
  { id: "6", title: "屈原与秭归", content: "屈原故里位于秭归县，每年端午节举行盛大的龙舟竞渡和祭祀活动。", source: "文化资料" },
];

export const sceneAudioData = {
  script: "各位游客，欢迎来到西陵峡口。这里是长江三峡中最长的峡谷，全长66公里，以滩多水急著称。西陵峡的形成可以追溯到约7000万年前的喜马拉雅造山运动，长江在此切穿了坚硬的石英砂岩层，形成了今天我们看到的壮丽景观。请大家注意看两岸的悬崖峭壁，上面有着丰富的地质层理...",
  duration: "3分28秒",
  voice: "鲟侠船长",
  status: "generated",
  generatedAt: "2026-05-20 14:30:00",
};